import { DocumentToolbar } from "@powerhousedao/design-system/connect";
import { useSetPHDocumentEditorConfig } from "@powerhousedao/reactor-browser";
import type {
  ProcessorApp,
  ProcessorApps,
} from "@powerhousedao/shared/processors";
import { useCallback } from "react";
import {
  addDocumentType,
  addProcessorApp,
  removeDocumentType,
  removeProcessorApp,
  setProcessorName,
  setProcessorStatus,
  setProcessorType,
} from "../../document-models/processor-module/index.js";
import { useSelectedProcessorModuleDocument } from "../hooks/useVetraDocument.js";
import { ProcessorEditorForm } from "./components/ProcessorEditorForm.js";
import { editorConfig } from "./config.js";

export default function Editor() {
  useSetPHDocumentEditorConfig(editorConfig);
  const [document, dispatch] = useSelectedProcessorModuleDocument();

  const onConfirm = useCallback(() => {
    // Dispatch all actions at once
    dispatch([setProcessorStatus({ status: "CONFIRMED" })]);
  }, [dispatch]);

  const onNameChange = useCallback(
    (name: string) => {
      if (name === document.state.global.name) return;
      dispatch(setProcessorName({ name }));
    },
    [document.state.global.name, dispatch],
  );

  const onTypeChange = useCallback(
    (type: string) => {
      if (type === document.state.global.type) return;
      dispatch(setProcessorType({ type }));
    },
    [document.state.global.type, dispatch],
  );

  const onAddDocumentType = useCallback(
    (id: string, documentType: string) => {
      dispatch(addDocumentType({ id, documentType }));
    },
    [dispatch],
  );

  const onRemoveDocumentType = useCallback(
    (id: string) => {
      dispatch(removeDocumentType({ id }));
    },
    [dispatch],
  );

  const onAddProcessorApp = useCallback(
    (processorApp: ProcessorApp) => {
      dispatch(addProcessorApp({ processorApp }));
    },
    [dispatch],
  );

  const onRemoveProcessorApp = useCallback(
    (processorApp: ProcessorApp) => {
      dispatch(removeProcessorApp({ processorApp }));
    },
    [dispatch],
  );

  return (
    <div className="bg-background p-6">
      <DocumentToolbar />
      <ProcessorEditorForm
        onNameChange={onNameChange}
        onTypeChange={onTypeChange}
        onAddDocumentType={onAddDocumentType}
        onRemoveDocumentType={onRemoveDocumentType}
        onAddProcessorApp={onAddProcessorApp}
        onRemoveProcessorApp={onRemoveProcessorApp}
        status={document.state.global.status}
        processorName={document.state.global.name ?? ""}
        processorType={document.state.global.type ?? ""}
        documentTypes={document.state.global.documentTypes ?? []}
        processorApps={document.state.global.processorApps as ProcessorApps}
        onConfirm={onConfirm}
      />
    </div>
  );
}
